module.exports = __webpack_public_path__ + "assets/img/news-5.7b7c9b0e.jpg";